import { InputNumber } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { requiredInputNumberRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface LengthProps {}

const Length: FC<LengthProps> = () => {
    const name = 'length'

    return (
        <Form.Item name={name} label={'Длина'} rules={requiredInputNumberRules}>
            <InputNumber />
        </Form.Item>
    )
}

export default Length
